<template>
  <div class="forestPage">
    <div class="forestMap" v-if="param.showMap">
      <!-- 地图页 -->
      <map-locator :param="mapData" mode="h5"></map-locator>
    </div>
    <div :class="['forestTab',this.param.showMap == false ? 'SmallTab' : '']" id="forestTab">
      <van-tabs v-model="activeName">
        <van-tab :title="$t('linLongMsg.baseTit')" name="forestMsg" class="baseMsg">
          <forest-msg :dataInfo="param"></forest-msg>
        </van-tab>
        <van-tab :title="$t('common.evaluateTit')" name="forestEvaluate" class="forestEvaluate">
          <forest-evaluate :dataInfo="param"></forest-evaluate>
        </van-tab>
        <van-tab :title="$t('common.commentTit')" name="forestComment" class="forestComment">
          <forest-comment :point="interiorPoint"  :paramData="param"  ></forest-comment>
        </van-tab>
        <van-tab :title="$t('common.publicityTit')" name="forestPublicity" class="forestPublicity">
          <forest-publicity :point="interiorPoint" ></forest-publicity>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 网络失败 -->
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
const mapLocator = () => import("@/components/map/MapLocator");
const refreshPage = () => import("@/components/common/refreshPage");
const forestMsg = () => import("@/components/forestModule/forestMsg");
const forestEvaluate = () => import("@/components/forestModule/forestEvaluate");
const forestComment = () => import("@/components/forestModule/forestComment");
const forestPublicity = () =>
  import("@/components/forestModule/forestPublicity");
// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "forest",
  data() {
    return {
      activeName: "baseMsg", //默认选中第一项
      forestId: "", //林地Id
      interiorPoint: "", //传递的林地内点
      refreshPage: false,
      mapData: {
        type: "geo_xiaoban",
        objid: ""
      },
      clientType: "" //手机类型
    };
  },
  props: {
    param: {
      type: Object,
      default: () => {
        {
          return {};
        }
      }
    }
  },
  mounted() {
    document.title = "林地信息";
    this.clientType = getDeviceType();
    this.$nextTick(function() {
      this.forestId = this.$route.query.commonId;
      if (JSON.stringify(this.param) === "{}") {
        this.param.showMap = true;
      }
      if (this.forestId == undefined) {
        this.forestId = this.param.id;
      }
      this.getPoint();
    });
  },
  components: {
    mapLocator,
    forestMsg,
    forestEvaluate,
    forestComment,
    forestPublicity,
    refreshPage
  },
  methods: {
    getPoint() {
      let _this = this;
      _this.$api.universal.forest
        .forestMsg(_this.forestId)
        .then(res => {
          if (res.code == "1") {
            console.log(res.data);
            _this.mapData.objid = res.data.objid;
            _this.interiorPoint = res.data.interiorPoint;
          } else {
            // console.log(res.msg);
          }
        })
        .catch(err => {
          this.refreshPage = true;
          console.log(err);
        });
    }
  },
  watch: {
    param: {
      handler: function() {
        let _this = this;
        _this.forestId = this.param.id;
        _this.getPoint();
      },
      deep: true
    }
  }
};
</script>
<style lang="less">
.forestPage {
  width: 100%;
  height: 100%;
  .forestMap {
    width: 100%;
    height: 40%;
    > div {
      height: 100%;
    }
  }
  .forestTab {
    width: 100%;
    height: 60%;
    .van-tabs {
      height: 100%;
      height: 100%;

      overflow: hidden;
      .van-tabs__line {
        background-color: #4bc08a;
      }
      .van-tab--active {
        .van-tab__text {
          color: #4bc08a;
        }
      }
      .van-tabs__wrap {
        height: 45px;
      }
      .van-tabs__content {
        width: 100%;
        height:90%;

        .van-tab__pane {
          width: 100%;
        }
        .forestComment.van-tab__pane,
        .baseMsg.van-tab__pane,
        .forestEvaluate.van-tab__pane,
        .forestPublicity.van-tab__pane {
          height: 100%;
          overflow-y: scroll;
          background-color: #fff;
        }
        .forestPublicity.van-tab__pane {
          background-color: #f6f6f6;
        }
      }
    }
  }
  .forestTab.SmallTab {
    height: 100%;
  }
}
</style>